export let NotificationSubscription;
(function (_NotificationSubscription) {
  let Area = /*#__PURE__*/function (Area) {
    Area["SITES"] = "Sites";
    Area["CAMPAIGNS"] = "Campaigns";
    Area["CONTACTS"] = "Contacts";
    Area["BILLING_AND_LEGAL"] = "Billing & Legal";
    Area["ORGANIZATION_AND_LEGAL"] = "Organization & Legal";
    return Area;
  }({});
  _NotificationSubscription.Area = Area;
})(NotificationSubscription || (NotificationSubscription = {}));